import { render, staticRenderFns } from "./MyYunicu.vue?vue&type=template&id=79da4962&scoped=true&"
import script from "./MyYunicu.vue?vue&type=script&lang=js&"
export * from "./MyYunicu.vue?vue&type=script&lang=js&"
import style0 from "./MyYunicu.vue?vue&type=style&index=0&id=79da4962&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79da4962",
  null
  
)

export default component.exports